module.exports = __webpack_public_path__ + "img/right-arrow.e5a2143f.svg";